import { Grid, withWidth, Box, InputAdornment, IconButton } from "@material-ui/core";
import React, { useEffect } from "react";
import { DeployButton } from "../../../../styles";
import { Text, Stack, Icon, Spinner, SpinnerSize, MessageBarType, MessageBar } from 'office-ui-fabric-react';
import Logo from "../../../../assert/images/ManageX-logo_new.webp";
import Button from "../../../../assert/images/button.png";
import LoginRedirectBg from "../../../../assert/images/loginRedirectBg.png";
import awslogo from "../../../../assert/images/AwsLogin.svg";
import microsoftlogo from "../../../../assert/images/MicrosoftLogin.svg";
import { CssTextField } from "../../../../styles";
import LandingPageBg from "../../../../assert/images/banner-bg.png";
import Amplify, { Auth } from "aws-amplify";
import config from '../../../../aws-exports';
import { AuthState } from "../../../../modules/redux/Auth/reducer";
import { RoleService } from "../../../Role/actions";
import { UserService } from "../../../User/actions";
import { useDispatch } from "react-redux";
import { AuthActions } from "../../../../modules/redux";
import Visibility from "@material-ui/icons/Visibility";
import VisibilityOff from "@material-ui/icons/VisibilityOff";
import { GetProvider } from "../../../../const";
Amplify.configure(config);

function LoginRedirect(props) {
    const dispatch = useDispatch();
    let [height, setHeight] = React.useState(window.innerHeight);
    const [awsLogin, setAwsLogin] = React.useState(false);
    const [email, setEmail] = React.useState("");
    const [password, setPassword] = React.useState("");
    const [awsLoading, setAwsLoading] = React.useState("");
    const [infoBar, setInfoBar] = React.useState(<span />);
    const resetChoice = React.useCallback(() => {
        setInfoBar(<span />)
    }, []);
    const [showPassword, setShowPassword] = React.useState(false);
    const [providerList, setProviderList] = React.useState([]);

    let updateWidthAndHeight = () => {
        setHeight(window.innerHeight);
    };

    useEffect(() => {
        window.addEventListener("resize", updateWidthAndHeight);
        return () => window.removeEventListener("resize", updateWidthAndHeight);
    });

    function awsSignIn() {
        setAwsLoading(true);
        let params = {
            username: email,
            password: password
        }
      
        Auth.signIn(params).then(res => {
            dispatch(AuthActions.SetProvider("aws-auth", res.attributes.email))
            checkUser();
        }).catch(err => {
            setAwsLoading(false);
            let msgBar = <MessageBar
                messageBarType={MessageBarType.error}
                isMultiline={false}
                onDismiss={resetChoice}
                dismissButtonAriaLabel="Close"
            >
                <span>{err.message.toString()}</span>
            </MessageBar>;
            setInfoBar(msgBar);
        });
    }

    function checkUser() {
        Auth.currentAuthenticatedUser()
            .then(user => {
                setAwsLoading(false);
                GetUserAndRole(user);
            })
            .catch(err => {
                setAwsLoading(false);
                let msgBar = <MessageBar
                    messageBarType={MessageBarType.error}
                    isMultiline={false}
                    onDismiss={resetChoice}
                    dismissButtonAriaLabel="Close"
                >
                    <span>{err.message.toString()}</span>
                </MessageBar>;
                setInfoBar(msgBar);
            })
    }


    function GetUserAndRole(user) {

        const success = (result, account = {}) => {
            return {
                type: AuthState.LOGGED_IN,
                payload: result,
                account: account,
                lastUrl: "",
            }
        }

        UserService.GetLoginUserDetails().then(res => {
            if (res.data.success) {
                RoleService.GetDataByUsingKeyAndOrgKey(res.data.data.role, res.data.data.orgInfo.orgId,).then(roleResult => {
                    if (roleResult.status !== 204) {
                        if (roleResult?.data?.status?.toLowerCase() === "active") {
                            res.data.data.roleInfo = roleResult.data;

                            let params = {
                                accessToken: user.signInUserSession.accessToken.jwtToken,
                                azureToken: user.signInUserSession.idToken.jwtToken,
                                tenantId: "",
                            }
                            dispatch(success(params, res.data.data));
                        }
                        else {
                            dispatch(AuthActions.logout(`User role in ${roleResult.data.status} State. Please contact admin.`));
                            props.setSignInClick(false);
                        }
                    } else {
                        dispatch(AuthActions.logout(`User role not found. Please contact admin.`));
                        props.setSignInClick(false);
                    }
                })
            } else {
                dispatch(AuthActions.logout(res.data.message));
                props.setSignInClick(false);
            }
        }).catch(err => {
            dispatch(AuthActions.logout(err.toString()));
            props.setSignInClick(false);
        });
    }

    useEffect(() => {
        GetProvider().then(res => {
            setProviderList(res.data.data);
        });
    }, []);

 
    return (
        <React.Fragment>
            <Grid
                container
                direction="row"
                justifyContent="center"
                alignItems="center"
                style={{
                    height: height,
                    backgroundImage: `url(${LandingPageBg})`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                }}
            >
                <Grid item xs={12} sm={awsLogin? 6 : 4} style={{ backgroundImage: `url(${LoginRedirectBg})`, backgroundPosition: 'center', backgroundSize:'cover' }}>
                    <div elevation={4} style={{ width: "100%", backgroundColor: 'transparent' }}>
                        {
                            awsLogin ? <div onClick={() => { setInfoBar(<span />); setAwsLogin(false); }} style={{ padding: 20 }}><Icon iconName="Back" style={{ cursor: "pointer", color: "#14E2C5" }} /></div> : <></>
                        }
                        <div id={"infoBar"} style={{ padding: "0px 20px 20px 20px", }}>{infoBar}</div>
                        <Grid
                            container
                            direction="row"
                            justifyContent="center"
                            alignItems="center"
                            style={{ padding: awsLogin ? "0px 20px 20px 0px" : "40px 40px 20px 40px",  }}
                        >
                           
                            <Grid item xs={12} sm={awsLogin ? 6 : 12} style={{ textAlign: "center" }}>                                
                                <Stack vertical >                                    
                                    <Stack.Item ><img src={Logo} alt={"LOGO"} width={awsLogin ? "70%" : "55%"}/></Stack.Item><br/><br/>
                                    <Stack.Item><Text style={{color:"#fff", fontSize:16}}>Sign in using</Text></Stack.Item>
                                    <Stack.Item align="center" style={{ paddingTop: 40, color: "#fff" }}>
                                        <Stack horizontal horizontalAlign="center" verticalAlign="center">
                                            <Grid
                                                container
                                                direction="row"
                                                justifyContent="center"
                                                alignItems="center"
                                                spacing={awsLogin? 2 : 5}
                                            >
                                                {
                                                    providerList.indexOf("azure") !== -1 ? <Grid item xs={5} sm={awsLogin ? 12 : providerList.length === 1 ? 8 : 5} style={{ cursor: "pointer", textAlign: "center" }} onClick={() => { props.onSignIn(); }}>
                                                        <Stack horizontal verticalAlign="center">
                                                            <img src={microsoftlogo} alt={"microsoftlogo"} width={awsLogin ? "50%" : "100%"} style={{ paddingLeft: awsLogin ? 70 : 0, }} />
                                                        </Stack>
                                                    </Grid> :<></>
                                                }
                                               
                                                {
                                                    awsLogin || providerList.length !== 2? <></> :
                                                    <Grid item xs={1} sm={1}>
                                                        <div style={{ width: 1.5, backgroundColor: "#fff", height: 30 }}></div>
                                                    </Grid>
                                                }
                                                {
                                                    providerList.indexOf("aws-auth") !== -1?
                                                        <Grid item xs={5} sm={awsLogin ? 12 : providerList.length === 1? 8 : 5 } style={{ cursor: "pointer", textAlign: "center" }} onClick={() => { setAwsLogin(true) }}>
                                                            <Stack horizontal verticalAlign="center">
                                                                <img src={awslogo} alt={"awslogo"} width={awsLogin? "50%" : "100%"} style={{ paddingLeft: awsLogin ? 70 : 0, }} />
                                                            </Stack>
                                                        </Grid> :<></>
                                                }
                                            </Grid>
                                        </Stack>
                                    </Stack.Item>
                                </Stack>
                            </Grid>
                            {
                                awsLogin ? <Grid item xs={2} sm={1} style={{ textAlign: "center",  }}>
                                    <div style={{ width: 1.5, textAlign: "center", backgroundColor: "#fff", height: 300 }}></div>
                                </Grid> : <></>
                            }
                           
                            {
                                awsLogin?
                                <Grid item xs={12} sm={5}>
                                        <Stack vertical style={{ padding: 0, }}>
                                            <Text style={{ color: "#fff", fontSize: 20, paddingLeft:5, paddingTop: 0 }}>Sign in to your account</Text>
                                        <Grid
                                            container
                                            direction="row"
                                            justifyContent="center"
                                            alignItems="center"
                                            spacing={3}
                                            style={{ paddingTop: 15 }}
                                        >
                                            <Grid item xs={12} sm={12}>
                                                <Box m={1}>
                                                    <CssTextField label="Email"
                                                        variant="outlined"
                                                        fullWidth
                                                       
                                                        inputProps={{ style: { fontSize: 12, height: 10, borderRadius: 5, backgroundColor: "#0C1F35", color: "white" } }}
                                                            onChange={(val) => {
                                                                setEmail(val.target.value);
                                                                let pattern = new RegExp(/^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i);
                                                               // setEmailError(pattern.test(val.target.value));
                                                            /*let temp = { ...props.requestTrialData };
                                                            temp["email"] = val.target.value;
                                                            props.setRequestTrialData(temp);
                                                            let pattern = new RegExp(/^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i);
                                                            props.setEmailError(pattern.test(val.target.value));*/
                                                        }}
                                                        />
                                                        {/*{
                                                            email === "" ? <div style={{ paddingLeft: '15px', color: 'red', fontSize: '10px' }}>Email is Required</div> : !emailError ? <div style={{ paddingLeft: '15px', color: 'red', fontSize: '10px' }}>Please enter vaild email</div> : <div />
                                                        }*/}
                                                    </Box>

                                            </Grid>
                                            <Grid item xs={12} sm={12}>
                                                <Box m={1}>
                                                    <CssTextField label="Password"
                                                        variant="outlined"
                                                            fullWidth
                                                            type={showPassword ? 'text' : "password"}
                                                            InputProps={{
                                                                endAdornment: <InputAdornment position="end">
                                                                    <IconButton

                                                                        aria-label="toggle password visibility"
                                                                        onClick={() => { setShowPassword(!showPassword); }}
                                                                        onMouseDown={() => { setShowPassword(false); }}
                                                                        edge="end"
                                                                    >
                                                                        {showPassword ? <VisibilityOff style={{ color: "white" }} /> : <Visibility style={{ color: "white" }} />}
                                                                    </IconButton>
                                                                </InputAdornment>,
                                                            }}
                                                            
                                                        inputProps={{ style: { fontSize: 12, height: 10, borderRadius: 5,/* backgroundColor: "#0C1F35",*/ color: "white" } }}
                                                            onChange={(val) => {
                                                                setPassword(val.target.value);
                                                            /*let temp = { ...props.requestTrialData };
                                                            temp["email"] = val.target.value;
                                                            props.setRequestTrialData(temp);
                                                            let pattern = new RegExp(/^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i);
                                                            props.setEmailError(pattern.test(val.target.value));*/
                                                        }}
                                                    />
                                                </Box>
                                                </Grid>
                                                <Grid item xs={12} sm={12} style={{textAlign:"center"}}>
                                                    <DeployButton
                                                        disabled={email === "" || password === ""}
                                                        style={{
                                                            backgroundImage: `url(${Button})`, backgroundPosition: 'center',
                                                            backgroundSize: 'cover'
                                                        }}
                                                        onClick={() => {
                                                            awsSignIn();
                                                        }}
                                                    >
                                                        {awsLoading ? <Spinner styles={{ root: { marginBottom: '0px' } }} size={SpinnerSize.small} /> : <Text style={{ fontSize: 14, fontWeight: 500 }}> Sign in</Text>}
                                                    </DeployButton>
                                                </Grid>
                                        </Grid>
                                    </Stack>
                                </Grid>:<></>
                            }
                            <Text onClick={() => { setInfoBar(<span />); props.setSignInClick(false); }} style={{ cursor:"pointer", color: "#fff", width: "100%", paddingTop: 20, fontSize: 14, textAlign: "center" }}>Back to <span style={{ color: "#14E2C5" }}>Home</span></Text>
                        </Grid>
                    </div>
                    
                </Grid>
                
            </Grid>

        </React.Fragment>
    );
}

export default withWidth()(LoginRedirect);